import { DateTime } from "luxon";
import { Client } from "../../../api/client";

export const processDWSynchTimestampToFrontendView = (timestamp: string) => {
    // Convert to datetime from ISO
    const dt: DateTime = DateTime.fromISO(timestamp);
    // Convert to pleasing for user frontend format
    return dt.toLocaleString(DateTime.DATETIME_MED);
}

// Fetch when last time the button was pressed that moves data from DW into our database for student profiles
// Inside OpportunitiesPagePartners component
export const fetchDWStudentProfileSyncTimestamp = (client: Client | null, isAdmin: boolean, setDWLastSynchTimestamp: (timestamp: string | null) => void) => {
    if (!client || !isAdmin) return;

    client.admin_GetLastDWStudentProfileSyncTimestamp()
        .then((timestamp) => {
            // If the API returns a string, update our state
            if (timestamp) {
                setDWLastSynchTimestamp(processDWSynchTimestampToFrontendView(timestamp));
            }
        })
        .catch(() => {
            // We usually don't want to show a toast error every single time 
            // a background poll fails, so we just log it.
            console.error("Background poll: Error retrieving DW sync timestamp");
        });
};